<template>
  <transition-group
    v-if="isOpened"
    name="c-modal-fade"
    appear
  >
    <c-modal-mask
      @close="emitClose()"
      show
      :key="actionText + 'mask'"
    />
    <div
      :class="classes"
      data-cy="cmodal"
      ref="cmodal"
      :key="name + 'modal'"
    >
      <div class="content">
        <slot />
      </div>

      <c-button
        v-if="!hideClose"
        size="lg"
        icon="cross"
        class="close"
        data-cy="close-modal-button"
        primary
        @click="emitClose()"
      />

      <c-button
        v-if="actionText && !hideAction"
        data-cy="modal-action-button"
        class="modal-action-button"
        icon-size="10"
        size="lg"
        :block="!isDesktop"
        :primary="isDesktop"
        :icon="actionIcon"
        :to="actionExternalLink || null"
        :external="!!actionExternalLink"
        :target="actionExternalTarget"
        :download="actionExternalDownload || null"
        :disabled="actionDisabled"
        :loading="actionLoading"
        @click="$emit('action')"
      >
        {{ actionText }}
      </c-button>
    </div>
  </transition-group>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    isOpened: Boolean,
    isFullscreen: {
      type: Boolean,
      default: true
    },
    actionExternalDownload: String,
    actionExternalLink: String,
    actionExternalTarget: String,
    actionText: String,
    actionIcon: {
      type: String,
      default: 'chevron-right'
    },
    actionDisabled: Boolean,
    actionLoading: Boolean,
    hideClose: Boolean,
    hideAction: Boolean,
    center: Boolean,
    isHorizontal: Boolean,
    isWhiteBackground: Boolean,
    modalSize: {
      type: String,
      default: '480px'
    }
  },
  computed: {
    classes () {
      return [
        'c-modal',
        this.name, {
        // '-center': this.center,
          '-fullscreen': this.isFullscreen,
          '-is-horizontal': this.isHorizontal,
          '-has-action': this.actionText,
          '-is-white': this.isWhiteBackground
        }]
    }
  },
  watch: {
    isOpened (v, old) {
      if (v === old) { return }
      this.checkOverflow()
    }
  },
  mounted () {
    this.checkOverflow()
  },
  beforeDestroy () {
    this.close()
  },
  methods: {
    setModalSize () {
      if (!this.isHorizontal) {
        const element = this.$refs.cmodal
        element.style.width = this.modalSize
      }
    },
    open () {
      const styles = {
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
      }
      Object.assign(document.body.style, styles)
      Object.assign(document.documentElement.style, styles)
    },
    close () {
      const styles = {
        overflow: '',
        position: '',
        height: ''
      }
      Object.assign(document.body.style, styles)
      Object.assign(document.documentElement.style, styles)
    },
    emitClose () {
      this.$emit('close')
      this.close()
    },
    checkOverflow () {
      if (this.isOpened) {
        this.open()
        this.$nextTick(() => {
          this.setModalSize()
        })
      } else {
        this.close()
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

$c-modal-spacing: 10px;
$c-modal-height: 40px + $c-modal-spacing * 2;

.c-modal {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  min-height: $c-modal-height;
  background-color: $background-color;
  z-index: 10;
  overflow: auto;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 20px 30px;

  @include mobile { padding: 10px; width: 100% !important; }

  &::-webkit-scrollbar {
    width: 13px;
  }
  &::-webkit-scrollbar-thumb {
    border: 3px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 7px;
    background-color: $scrollbar-color;
  }

  &.-is-white { background-color: #fff; }

  &.-has-action {
    @include mobile { padding-bottom: 75px; }
  }

  @include desktop {
    top: 80px;
    max-height: calc(100vh - 160px);
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    min-height: 300px;
    padding-bottom: 40px;
    border-radius: 3px;

    // &.-center {
      // top: 50%;
      // transform: translateY(calc(-50% - 100px));
    // }
  }

  &.-is-horizontal {
    max-width: 800px;
    width: auto;
    padding-bottom: 30px;
  }

  &.-fullscreen {
    @include mobile { height: 100%; }
  }

  & > .content { width: 100%; }

  & > .close {
    position: absolute;
    top: 0;
    right: 0;
    margin: 10px;

    & > .icon { fill: white !important }
  }
}

.c-modal-fade {
  @at-root {
    #{&}-enter-active,
    #{&}-leave-active {
      transition: opacity .4s ease;
    }
    #{&}-enter,
    #{&}-leave-to {
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CComponents/CModal.vue